import React from "react";
import AlertModal, { AlertModalProps } from "./AlertModal";
import SafariIcon from "../../img/Safari.svg";
import ChromeIcon from "../../img/Chrome.svg";
import { Typography } from "@mui/material";
import PhonelinkEraseRounded from "@mui/icons-material/PhonelinkEraseRounded";

const InstagramModal: React.FC<AlertModalProps> = ({ open, onClose }) => {
    const alertText = (
        <Typography
            fontWeight={400}
            fontSize="14px"
            lineHeight="150%"
            color="text.secondary"
            textAlign="center"
        >
            We detected that the app is opened in Instagram, and some
            features might not work. <br />
            <br />
            For stable functioning, click 3 dots at the top and open the app
            in{" "}
            <img
                src={SafariIcon}
                alt="Safari Icon"
                width="18px"
                height="18px"
                style={{ verticalAlign: "middle" }}
            />{" "}
            Safari for iPhone and{" "}
            <img
                src={ChromeIcon}
                alt="Chrome Icon"
                width="18px"
                height="18px"
                style={{ verticalAlign: "middle" }}
            />{" "}
            Google Chrome for Android.
        </Typography>
    );

    return (
        <AlertModal
            open={open}
            onClose={onClose}
            alertText={alertText}
            headingText="Open in Browser"
            icon={<PhonelinkEraseRounded sx={{ fontSize: 24 }} />}
        />
    );
};

export default InstagramModal;
